import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";
import { scrollToId, scrollToTop } from "@/lib/scroll";

const LINKS = [
    { id: "what-we-do", label: "What we do" },
    { id: "sectors", label: "Sectors" },
    { id: "network", label: "Network" },
    { id: "contact", label: "Contact" },
];

const Nav = () => {
    const [open, setOpen] = useState(false);
    const go = (id) => {
        setOpen(false);
        scrollToId(id);
    };

    return (
        <header className="fixed top-0 z-50 w-full border-b border-ink/10 bg-paper/85 backdrop-blur-md">
            <div className="container-x flex h-[72px] items-center justify-between">
                <button
                    data-testid="nav-logo"
                    onClick={scrollToTop}
                    className="cursor-pointer"
                    aria-label="Everlast Partners — back to top"
                >
                    <Logo />
                </button>

                <nav className="hidden items-center gap-9 md:flex">
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={() => go(l.id)}
                            className="group relative font-mono text-[11px] uppercase tracking-[0.22em] text-inksoft transition-colors duration-200 hover:text-ink"
                        >
                            {l.label}
                            <span className="absolute -bottom-1 left-0 h-px w-0 bg-olive transition-all duration-300 group-hover:w-full" />
                        </button>
                    ))}
                    <button
                        data-testid="nav-request-intro-btn"
                        onClick={() => go("contact")}
                        className="group flex items-center gap-2 rounded-full bg-olive px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.18em] text-paper transition-colors duration-300 hover:bg-olive-deep"
                    >
                        Request an introduction
                        <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                    </button>
                </nav>

                <button
                    className="md:hidden"
                    data-testid="nav-mobile-toggle"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                >
                    {open ? (
                        <X className="h-6 w-6" />
                    ) : (
                        <Menu className="h-6 w-6" />
                    )}
                </button>
            </div>

            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden border-t border-ink/10 bg-paper md:hidden"
                    >
                        <div className="container-x flex flex-col gap-1 py-5">
                            {LINKS.map((l) => (
                                <button
                                    key={l.id}
                                    data-testid={`nav-mobile-link-${l.id}`}
                                    onClick={() => go(l.id)}
                                    className="py-3 text-left font-serif text-2xl text-ink"
                                >
                                    {l.label}
                                </button>
                            ))}
                            <button
                                data-testid="nav-mobile-request-intro-btn"
                                onClick={() => go("contact")}
                                className="mt-3 rounded-full bg-olive py-3.5 font-mono text-xs uppercase tracking-[0.18em] text-paper"
                            >
                                Request an introduction
                            </button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </header>
    );
};

export default Nav;
